<template>
    <div>
        <modal
            class="new-modal-small"
            :name="modal_name"
            transition="nice-modal-fade"
            :delay="100"
            height="auto"
            :min-height="200"
            :min-width="400"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="false"
            style="pointer-events:inherit !important" 
            v-bind:click-to-close="false"
        >
            <div class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center" style="background-color: #fff !important; height: 30em !important;">
                <img src="/static/images/trash-big.svg" style="height: 10rem !important" />
                <div class="mt-5" style="font-size: 16px">
                    <div class="mb-4" style="font-size: 20px; color: #f30d0d">Remove Follower</div>
                    Are you sure you want to remove <br> <span class="fw-600">{{ user_name }}</span> ?
                </div>
                <div class="d-flex aligin-items-center justify-content-center mt-6">
                    <button class="btn btn-des-small mr-4 px-4" style="background: transparent; color: #0d5be6; border: 1px solid #0d5be6; width: 8em" @click="hideSelf">Cancel</button>
                    <button class="btn btn-des-small ml-4 px-4" style="background: #005dae; color: #fff; border: 1px solid #005dae; width: 8em" @click="removeFollowerConfirm">Remove</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    props: ["modal_name","user_name"],
    methods: {
        hideSelf() {
            this.$modal.hide(this.modal_name);
        },
        removeFollowerConfirm() {
            this.$emit("removeFollowerConfirm");
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/alertModals/RemoveFollower.vue